import { createTheme } from '@mui/material/styles';


// I want my theme to be as per deere standard that is green (#367C2B) and yellow (#FFDE00) and text to be black (#000000)
export const theme = createTheme({
  palette: {
    primary: {
      main: '#367C2B', // Green
    },
    secondary: {
      main: '#FFDE00', // Yellow
    },
    text: {
      primary: '#000000', // Black
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
  },
  components: {
    // MaterialTable toolbar and selection text styling
    MuiToolbar: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            color: '#000000', // Black color for selection text
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body2: {
          color: '#000000', // Black color for body text including selection count
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#FFDE00', // Checked color
          },
          '&.MuiCheckbox-indeterminate': {
            color: '#FFDE00', // Indeterminate color (for select all)
          },
        },
      },
    },
  },
});


export const providerOrdersURL = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/getProviderOrders/`;

export const additionalInfoURL = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/getAdditionalInfo/`;

export const welcomeMessage = `Freight order manager is a tool that automates the task of the Order
Fullfilment department by automating various processes like finding
valid routes for shipping orders ,find the suppliers, the shipping
cost and automatically generate the purchase order and send the
invoice by email or EDI to the respective forwarders.`;
